import React, { useEffect, useState, useMemo } from 'react'
import { Button, Select, Modal, message } from 'antd'
import { useSelector } from 'react-redux'
import { getApplicationByProjects } from '../../../services/application'
import { addToApplication } from '../../../services/application-items'
import { APP_STATUS_PROGRESS } from '../../reports/constants'
import { userSelector } from '../../../store/session'

const ApplicationSelectModal = ({ showModal, onChancel, applicationItem }) => {
  const { user } = useSelector(userSelector)
  const [isLoading, setIsLoading] = useState(false)
  const [applications, setApplication] = useState([])
  const [selectedValue, setSelectedValue] = useState(null)

  const isProject = useMemo(() => user?.role?.type === 'project_manager', [user])

  const options = useMemo(
    () =>
      applications.map((item) => ({
        label: item.id,
        value: item.id,
      })),
    [applications]
  )
  useEffect(() => {
    if (applicationItem) {
      setIsLoading(true)
      const projectId = applicationItem.project.id
      getApplicationByProjects([projectId], isProject ? 'all' : APP_STATUS_PROGRESS, { page: 1, pageSize: 300 })
        .then((response) => {
          setApplication(response?.data?.data?.attributes.results || [])
        })
        .catch((error) => {
          message.error('Ошибка получения списка заявок')
        })
        .finally(() => setIsLoading(false))
    }
  }, [applicationItem])

  const chancelHandler = () => {
    onChancel()
    setSelectedValue(null)
  }

  const onAddHandler = () => {
    const selectedApplication = applications.find((item) => item.id === selectedValue)
    if (selectedApplication && selectedApplication.implementation) {
      const data = {
        data: {
          implementation: selectedApplication.implementation.id,
          application: selectedApplication.id,
        },
      }
      setIsLoading(true)
      addToApplication(applicationItem.id, data)
        .then(() => {
          onChancel(true)
          setSelectedValue(null)
          message.success(`Позиция успешно добавлена в заявку ${selectedApplication.id}`)
        })
        .catch(() => {
          message.error('Ошибка добавления в заявку')
        })
        .finally(() => setIsLoading(false))
    }
  }

  return (
    <Modal
      title="Выбрать заявку для добавления"
      visible={showModal}
      onCancel={chancelHandler}
      footer={[
        <Button key="back" onClick={chancelHandler} disabled={isLoading}>
          Отмена
        </Button>,
        <Button key="return" type="primary" onClick={onAddHandler} disabled={isLoading || !selectedValue}>
          Добавить в заявку
        </Button>,
      ]}
    >
      <Select
        showSearch
        style={{ width: '100%' }}
        value={selectedValue}
        loading={isLoading}
        options={options}
        onChange={(value) => setSelectedValue(value)}
        filterOption={(input, option) => `${option?.label || ''}`.includes(input)}
      />
    </Modal>
  )
}

export default ApplicationSelectModal
